<template>
  <div class="container" v-if="posts">
  <div class="row justify-content-center">
    <div class="col-lg-9 text-center">
      <h3 class="fw-normal font-body">
        {{ posts.subscribe_0 }}
      </h3>
    </div>
  </div>
  <div class="row justify-content-center my-3">
    <div class="col-lg-8">
      <form class="form form--contact" method="post" @submit.prevent="submitForm($event)" id="formEmailAlerts" autocomplete="off">
        <Modal
          v-model="showModal"
          :title="formTitle"
          :status="formSuccess"
          :message="formMessage"
          @close="resetModal"
          template="emailAlerts"
        />
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="form-label" for="full_name">{{ translate("fullname") }}*</label>
          <input class="form-control" type="text" name="full_name" id="full_name" maxlength="100" required>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="form-group">
          <label class="form-label" for="email_address">{{ translate("email") }}*</label>
          <input class="form-control" type="email" name="email_address" id="email_address" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" maxlength="50" required>
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          <div class="custom-control custom-checkbox">
                <input 
                type="checkbox" 
                class="custom-control-input" 
                name="privacyStatement"
                v-model="isChecked"
                @change="handleCheckboxChange"
                >
                <label class="custom-control-label" v-html="translate('privacy.statement.text')"></label>
          </div>
        </div>
      </div>

      <div class="col-12 text-center mt-3">
        <button 
            type="submit" 
            class="btn btn--secondary" 
            :disabled="!isChecked"
            >
            <span class="btn__title">{{ translate("submit") }}</span>
        </button>
      </div>

      <div class="col-12 text-center mt-4">
        <NuxtLink
          :to="localePath('/investor-relations/information-inquiry/email-alerts-unsubscribe')"
          class="link-white"
        >
          {{ translate("note") }}: {{ posts.subscribe_2 }}
        </NuxtLink>
      </div>

    </div>


  </form>
    </div>
  </div></div>
</template>
<script setup>
import { useEmailAlerts } from "@/composables/useEmailAlerts";

import Modal from "@/components/helpers/Modal.vue";
import Loading from "@/components/helpers/Loading.vue";
const isChecked = ref(false)


const localePath = useLocalePath();

const props = defineProps({
  posts: {
    type: Object,
    required: true,
  },
});

// ใช้ Composable
const {
  isLoading,
  LoadingTitle,
  formSuccess,
  formTitle,
  formMessage,
  showModal,
  privacyStatement,
  translate,
  submitForm,
  resetModal,
} = useEmailAlerts();

</script>

<style lang="scss"></style>
